
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../../styles/ui.css';
import './UserProfileForm.css';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

const UserProfileForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isAdmin = Boolean(id);
  const loggedInId = localStorage.getItem('researcherId');

  const [formData, setFormData] = useState({
    first_name: '',
    middle_name: '',
    last_name: '',
    email: '',
    address: '',
    city: '',
    state_province: '',
    country: '',
    nationality: '',
    date_of_birth: '',
    telephone_number: '',
    gender: '',
    role_id: '3',
    password: '',
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userId = isAdmin ? id : loggedInId;
    fetch(`${API_BASE_URL}/users/${userId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setFormData((prev) => ({
          ...prev,
          first_name: data.first_name || '',
          middle_name: data.middle_name || '',
          last_name: data.last_name || '',
          email: data.email || '',
          address: data.address || '',
          city: data.city || '',
          state_province: data.state_province || '',
          country: data.country || '',
          nationality: data.nationality || '',
          date_of_birth: data.date_of_birth || '',
          telephone_number: data.telephone_number || '',
          gender: data.gender || '',
          role_id: data.role_id?.toString() || '3',
        }));
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to load user:', err);
        setLoading(false);
      });
  }, [id, isAdmin, loggedInId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userId = isAdmin ? id : loggedInId;

    try {
      const res = await fetch(`${API_BASE_URL}/users/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        alert('User updated successfully');
        if (isAdmin) navigate('/admin/users');
      } else {
        const err = await res.json();
        alert(err.message || 'Update failed');
      }
    } catch (err) {
      console.error('Update error:', err);
    }
  };

  if (loading) {
    return (
      <div className="proposal-details-container">
        <div className="card">
          <div className="empty-state">Loading…</div>
        </div>
      </div>
    );
  }

  return (
    <div className="proposal-details-container">
      <div className="card">
        <div className="details-header">
          <h2>{isAdmin ? 'Edit User Profile' : 'My Profile'}</h2>
          {isAdmin && <span className="status-pill-header">Admin</span>}
        </div>

        <form onSubmit={handleSubmit} className="form-grid two-col profile-form">
          <div className="form-field">
            <label>First Name</label>
            <input className="input-std" name="first_name" type="text" value={formData.first_name} onChange={handleChange} required />
          </div>

          <div className="form-field">
            <label>Middle Name</label>
            <input className="input-std" name="middle_name" type="text" value={formData.middle_name} onChange={handleChange} />
          </div>

          <div className="form-field">
            <label>Last Name</label>
            <input className="input-std" name="last_name" type="text" value={formData.last_name} onChange={handleChange} required />
          </div>

          <div className="form-field">
            <label>Email</label>
            <input className="input-std" name="email" type="email" value={formData.email} onChange={handleChange} required />
          </div>

          <div className="form-field">
            <label>New Password</label>
            <input className="input-std" name="password" type="password" value={formData.password} onChange={handleChange} placeholder="Leave blank to keep current password" />
          </div>

          <div className="form-field">
            <label>Telephone</label>
            <input className="input-std" name="telephone_number" type="tel" value={formData.telephone_number} onChange={handleChange} />
          </div>

          <div className="form-field">
            <label>Gender</label>
            <select className="select-std" name="gender" value={formData.gender} onChange={handleChange}>
              <option value="">Select</option>
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </select>
          </div>

          <div className="form-field">
            <label>Date of Birth</label>
            <input className="input-std" name="date_of_birth" type="date" value={formData.date_of_birth} onChange={handleChange} />
          </div>

          <div className="form-field">
            <label>City</label>
            <input className="input-std" name="city" type="text" value={formData.city} onChange={handleChange} />
          </div>

          <div className="form-field">
            <label>State/Province</label>
            <input className="input-std" name="state_province" type="text" value={formData.state_province} onChange={handleChange} />
          </div>

          <div className="form-field">
            <label>Country</label>
            <input className="input-std" name="country" type="text" value={formData.country} onChange={handleChange} />
          </div>

          <div className="form-field">
            <label>Nationality</label>
            <input className="input-std" name="nationality" type="text" value={formData.nationality} onChange={handleChange} />
          </div>

          {}
          <div className="form-field col-span-2">
            <label>Address</label>
            <input className="input-std" name="address" type="text" value={formData.address} onChange={handleChange} />
          </div>

          {}
          {isAdmin && (
            <div className="form-field col-span-2">
              <label>Role</label>
              <select className="select-std" name="role_id" value={formData.role_id} onChange={handleChange} required>
                <option value="2">ERC Staff</option>
                <option value="3">Reviewer</option>
                <option value="4">Secretary</option>
              </select>
            </div>
          )}

          {}
          <div className="btn-row right col-span-2" style={{ marginTop: 8 }}>
            <button className="btn ghost" type="button" onClick={() => navigate(-1)}>Cancel</button>
            <button className="btn primary" type="submit">Update</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserProfileForm;
